export default __webpack_public_path__ + "media/apps/Configurator/images/Whats-Included-Logo-93403b28f02a8b5734b80f855d2cfd63.png";